import React from 'react';
import { Checkbox, Divider, Form, Icon, Input } from 'antd';
import DadataSearchBank from '../../../../Customers/modules/dadataBank/container';
import { isNumeric } from '../../../../../common/utils/validation';

export const BankInfo = ({ form, disabled }) => {
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
    function handleChange(val, index) {
        val &&
            val.data &&
            setFieldsValue({
                ['bankName' + index]: val.data.name.payment,
                ['bik' + index]: val.data.bic,
                ['accountCorr' + index]: val.data.correspondentAccount,
            });
        updateBanks(val, index);
    }
    const deleteBank = index => {
        banks.splice(index, 1);
        setFieldsValue({ banks });
    };
    const banks = getFieldValue('bankAccount') || [];
    const banksLen = (banks && banks.length) || 0;
    const renderAccount = (item, index) => {
        const autoSearchBankActive = getFieldValue('autoSearchBankActive' + index);
        return (
            <div key={'bankAccount' + index}>
                {!disabled || (banks[index].bankName && banks[index].bik && banks[index].accountCorr && banks[index].bankAccountNum) ? 
                <>
                <Divider />
                {!disabled && (
                    <>
                        <div className="offer-card__item">
                            <span className="offer-card__non-label">
                                <Form.Item>
                                    {getFieldDecorator('autoSearchBankActive' + index, {
                                        valuePropName: 'checked',
                                    })(
                                        <Checkbox style={{ fontWeight: 'normal' }}>
                                            Автоматическое определение данных организации по
                                            наименованию или ИНН
                                        </Checkbox>
                                    )}
                                </Form.Item>
                            </span>
                        </div>
                        {autoSearchBankActive && (
                            <div className="offer-card__item">
                                <span className="label">Банк:</span>
                                <DadataSearchBank
                                    style={{ width: 368 }}
                                    form={form}
                                    handleChange={e => handleChange(e, index)}
                                />
                            </div>
                        )}
                    </>
                )}
                <Form.Item>
                    {getFieldDecorator('bankAccountId' + index)(
                        <Input
                            hidden
                            disabled
                        />
                    )}
                </Form.Item>
                <div key={'bankName' + index} className="offer-card__item">
                    <span className="label">Наименование банка:</span>
                    <Form.Item>
                        {getFieldDecorator('bankName' + index, {
                            rules: [{required: true, message: "Поле, обязательное для заполнения"}]
                        })(
                            <Input
                                style={{ width: 368 }}
                                placeholder="Укажите наименование банка"
                                disabled={disabled || autoSearchBankActive}
                                onChange={e =>
                                    updateBankField(index, 'bankName', e.target.value)
                                }
                            />
                        )}
                    </Form.Item>
                </div>
                <div key={'bik' + index} className="offer-card__item">
                    <span className="label">БИК:</span>
                    <Form.Item>
                        {getFieldDecorator('bik' + index, {
                            rules: [{required: true, message: "Поле, обязательное для заполнения"},
                            {
                                validator: (rule, value, callback) => {
                                    if (!isNumeric(value) && value) {
                                        callback('Недопустимый символ');
                                    } else if (Array.from(value).length < 9){
                                        callback('БИК должен быть длиной в 9 цифр');
                                    } else {
                                        callback();
                                    }
                                }, 
                            }]
                        })(
                            <Input
                                style={{ width: 224 }}
                                placeholder="Укажите БИК"
                                maxLength={9}
                                disabled={disabled || autoSearchBankActive}
                                onChange={e =>
                                    updateBankField(index, 'bik', e.target.value)
                                }
                            />
                        )}
                    </Form.Item>
                </div>
                <div key={'accountCorr' + index} className="offer-card__item">
                    <span className="label">Корреспондентский счет:</span>
                    <Form.Item>
                        {getFieldDecorator('accountCorr' + index, {
                            rules: [{required: true, message: "Поле, обязательное для заполнения"},
                            {
                                validator: (rule, value, callback) => {
                                    if (!isNumeric(value) && value) {
                                        callback('Недопустимый символ');
                                    } else {
                                        callback();
                                    }
                                },
                            }]
                        })(
                            <Input
                                placeholder="Укажите корр. счет"
                                style={{ width: 224 }}
                                maxLength={22}
                                disabled={disabled || autoSearchBankActive}
                                onChange={e =>
                                    updateBankField(index, 'accountCorr', e.target.value)
                                }
                            />
                        )}
                    </Form.Item>
                </div>
                <div key={'bankAccountNum' + index} className="offer-card__item">
                    <span className="label">Расчетный счет:</span>
                    <Form.Item>
                        {getFieldDecorator('bankAccountNum' + index, {
                            rules: [
                                {required: true, message: "Поле, обязательное для заполнения"},
                                {
                                    validator: (rule, value, callback) => {
                                        if (!isNumeric(value) && value) {
                                            callback('Недопустимый символ');
                                        } else {
                                            callback();
                                        }
                                    },
                                },
                            ],
                        })(
                            <Input
                                placeholder="Укажите расчетный счет"
                                style={{ width: 224 }}
                                maxLength={20}
                                onChange={e =>
                                    updateBankField(index, 'bankAccountNum', e.target.value)
                                }
                                disabled={disabled}
                            />
                        )}
                    </Form.Item>
                </div>
                </>
                : null}

                {!disabled && (
                    <div className="offer-card__item" style={{ marginTop: -25 }}>
                        <span className="label" />
                        <div
                            className="add-more-link"
                            onClick={() => deleteBank(index)}
                            style={{
                                color: '#00a8ff',
                                cursor: 'pointer',
                                display: 'inline-block',
                            }}
                        >
                            <Icon type="minus-circle" />
                            Удалить банковские реквизиты по этому банку
                        </div>
                    </div>
                )}
            </div>
        );
    };
    
    const addNewBank = () => {
        banks.push({
            bankName: null,
            bik: null,
            accountCorr: null,
            bankAccountNum: null,
        });

        setFieldsValue({ banks }, () => {
            let obj = {};
            let bankName = getFieldValue('bankName' + banksLen)
            let bik = getFieldValue('bik' + banksLen)
            let accountCorr = getFieldValue('accountCorr' + banksLen)
            let bankAccountNum = getFieldValue('bankAccountNum' + banksLen)
            bankName = null
            bik = null
            accountCorr = null
            bankAccountNum = null
            obj[`bankName${banksLen}`] = bankName
            obj[`bik${banksLen}`] = bik
            obj[`accountCorr${banksLen}`] = accountCorr
            obj[`bankAccountNum${banksLen}`] = bankAccountNum
            setFieldsValue({ ...obj });
        });
    };
    const updateBankField = (index, field, value) => {
        banks[index][field] = value;
    };
    const updateBanks = (val, index) => {
        if (banks[index]) {
            banks[index].bankName = val.data.name.payment;
            banks[index].bik = val.data.bic;
            banks[index].accountCorr = val.data.correspondentAccount;
            banks[index].bankAddress = val.data.address.unrestrictedValue
                ? val.data.address.unrestrictedValue
                : null;
        }
    };
    return (
        <>
            <Form.Item className="hidden-block">
                {getFieldDecorator('bankAccount')(
                    <Input type="hidden" disabled={true} />
                )}
            </Form.Item>
            {banksLen > 0 &&
                banks.map((item, index) => {
                    return renderAccount(item, index);
                })}
            {!disabled && (
                <div className="offer-create__item" style={{ marginTop: 45 }}>
                    <span className="offer-card__non-label">
                        <div
                            className="add-more-link"
                            onClick={addNewBank}
                            style={{
                                color: '#00a8ff',
                                cursor: 'pointer',
                                display: 'inline-block',
                            }}
                        >
                            <Icon type="plus-circle" />
              Добавить реквизиты банка
            </div>
                    </span>
                </div>
            )}
        </>
    );
};
